import imageAss from "../../img/logoAssembleia.png?width=380px";
import BtnHomeOpBase from "../components/abstracts/btnHomeOpBase";
import ComponentBase from "../components/abstracts/componentBase";
import BtnConstitution from "../components/btnOpHome/btnConstitution";
import BtnGaleria from "../components/btnOpHome/btnGaleria";
import BtnQuiz from "../components/btnOpHome/btnQuiz";
import BtnSymbols from "../components/btnOpHome/btnSymbols";
import BtnVisitaGuiada from "../components/btnOpHome/btnVisitaGuiada";
import HistoryBtn from "../components/history/btnHistory";
import I18n from "../i18n";



export default class PageHome extends ComponentBase{
    private historyContainer:HTMLElement;
    private btnContainer:HTMLElement;

    private static idElement = "home"
    private static elementToRender = `
        <div id="${PageHome.idElement}">
            <h2 class="main-title">${I18n.apply("O Palácio da Assembleia Nacional")}</h2>
            <div class="container-hist">
            </div>
            <div class="home-ptions">
            </div>
        </div>
    `;

    constructor(protected container:HTMLElement){
        super(container,PageHome.idElement,PageHome.elementToRender);
    }

    public renderBtnHistory():HistoryBtn{
        this.historyContainer = this.elementRendered.querySelector(".container-hist");
        return new HistoryBtn(this.historyContainer);
    }

    public renderBtnOptions():BtnHomeOpBase[]{
        this.btnContainer = this.elementRendered.querySelector(".home-ptions");
        return [
            //new BtnVisitaGuiada(this.btnContainer),
            //new BtnConstitution(this.btnContainer),
            //new BtnGaleria(this.btnContainer),
            //new BtnSymbols(this.btnContainer),
            new BtnQuiz(this.btnContainer)
        ]
    }

    // public addEventContinue(cb:(btnClicked:HTMLButtonElement)=>void){
    //     let btnContinue = this.elementRendered.querySelector("button") as HTMLButtonElement;
    //     btnContinue.addEventListener("click",function(){
    //         cb(btnContinue);
    //     });
    // }
}